import { render, staticRenderFns } from "./leadBV.vue?vue&type=template&id=79e444f5&scoped=true"
import script from "./leadBV.vue?vue&type=script&lang=js"
export * from "./leadBV.vue?vue&type=script&lang=js"
import style0 from "./leadBV.vue?vue&type=style&index=0&id=79e444f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e444f5",
  null
  
)

export default component.exports